<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Secrétariat" />
            <LesSecretariat/>
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import FooterComp from '../Layouts/FooterComp'
import LesSecretariat from './LesSecretariat.vue'



export default {
    name: 'SecretariatPage',
    components: {
        NavBar,
        PageTitle,
        LesSecretariat,
        FooterComp,
    }
}
</script>